<template>
  <div class="bottom-bar-layout">
    <div class="page-content"
         id="page-content"
         :style="contentStyle"
    >
      <slot></slot>
    </div>

    <ym-tabbar v-if="showBar"
               class="bottom-bar"
               :class="{ 'ym-in-app': isAppWebView }"
               safe-area-inset-bottom
               :style="barStyle"
               :border="false"
    >
      <slot name="tabbar"></slot>
    </ym-tabbar>
  </div>
</template>

<script>
  import { Tabbar } from '@ymba/ym-ui';
  import { mapGetters } from 'vuex';
  import { addUnit, isAppWebView } from '@/utils';

  export default {
    name: 'BottomBarLayout',
    components: {
      'ym-tabbar': Tabbar,
    },
    props: {
      showBar: {
        type: Boolean,
        required: true,
      },
      barHeight: {
        type: Number,
        default: 120,
      },
      barBackground: {
        type: String,
        default: '#fff',
      },
      shadow: {
        type: Boolean,
        default: true,
      },
      targetId: {
        type: Number,
        default: 0,
      },
      targetType: {
        type: String,
        default: '',
      },
      showConsult: {
        type: Boolean,
        default: false,
      },
      isShowGuidePopup: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        isAppWebView: isAppWebView(),
      };
    },
    computed: {
      ...mapGetters([
        'showPopup',
        'showInnerPopup',
      ]),
      barStyle() {
        const result = {};
        result.background = this.barBackground;
        if (this.barHeight) {
          result.height = `${addUnit(this.barHeight)}`;
        }
        if (!this.shadow) {
          result.boxShadow = 'none';
        }
        return result;
      },
      contentStyle() {
        const style = {};
        if (this.showBar && this.barHeight) {
          style.paddingBottom = `calc(${addUnit(this.barHeight)} + env(safe-area-inset-bottom))`;
        }
        return style;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .bottom-bar-layout {
    height: 100vh;
    height: 100%;
  }

  .page-content {
    width: 100%;
    height: 100vh;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
  }

  .bottom-bar {
    font-size: @font-size-medium;
    height: @bottom-bar-height;
    background: none;
    box-shadow: @tabbar-box-shadow;
  }

</style>
